import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAppContext} from "../../contexts/AppContext";
import {NotificationCard} from "./NotificationCard";
import {useEffect, useState} from "react";
import {
    verificaChangelogs,
    marcarNotificacaoComoLida,
    atualizaChangelogNotificacao
} from "../screens/admin/configs/functions";

export const NotificationsManager = () => {
    const { dadosUsuario } = useAppContext();
    const queryClient = useQueryClient();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [notificacoes, setNotificacoes] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const usuarioId = dadosUsuario?.pessoa?.id_pessoa;

    const { data } = useQuery({
        queryKey: ["notificacoes", usuarioId],
        queryFn: async () => {
            if (!usuarioId) return [];
            const result = await verificaChangelogs({ id_pessoa: usuarioId });
            return result?.data || [];
        },
        enabled: !!usuarioId,
    });

    useEffect(() => {
        if (!data) return;
        const pendentes = Array.isArray(data.data) ? data.data.filter(n => !n.lido) : [];
        if (pendentes.length > 0) {
            const formatados = pendentes.map(n => ({
                id: n.id,
                lido: n.lido,
                dataLeitura: n.dataLeitura,
                changelogId: n.changelog.id,
                ...n.changelog
            }));
            setNotificacoes(formatados);
            setCurrentIndex(0); // Resetar para primeira notificação
            setPreviewOpen(true);
        }
    }, [data]);

    const marcarComoLidoMutation = useMutation({
        mutationFn: (idNotificacao) => atualizaChangelogNotificacao(idNotificacao, { lido: '1' }),
        onSuccess: (_, idNotificacao) => {
            setNotificacoes(prev =>
                prev.map(n => n.id === idNotificacao ? { ...n, lido: true } : n)
            );
            queryClient.invalidateQueries({ queryKey: ["notificacoes", usuarioId] });
        }
    });

    const handleMarcarComoLido = (id) => {
        marcarComoLidoMutation.mutate(id);
    };

    const handleProxima = () => {
        if (currentIndex < notificacoes.length - 1) {
            setCurrentIndex(currentIndex + 1);
        } else {
            setPreviewOpen(false);
        }
    };

    const handleAnterior = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleFechar = () => {
        setPreviewOpen(false);
        setCurrentIndex(0);
    };

    if (!notificacoes.length) return null;

    return (
        <NotificationCard
            systems={[]}
            formValues={notificacoes[currentIndex]}
            previewOpen={previewOpen}
            setPreviewOpen={handleFechar}
            isUserRead={true}
            onMarcarComoLido={() => handleMarcarComoLido(notificacoes[currentIndex].id)}
            currentIndex={currentIndex}
            totalNotificacoes={notificacoes.length}
            onProxima={handleProxima}
            onAnterior={handleAnterior}
        />
    );
};